import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { ApiService } from '../core/http/api.service';
import { API_CONFIG } from '../shared/_config/api.config';

@Injectable({ providedIn: 'root' })
export class AuthService {
    constructor(
        private apiService: ApiService,
    ) { }

    isAuthorized() {
        if (this.getAccessToken()) {
            return true;
        }
        return false;
    }

    getAccessToken() {
        return localStorage.getItem('accessToken');
    }

    getUserID(): string | null {
        const token = this.getAccessToken();
        if (!token) {
            return null;
        }

        try {
            // JWT token has 3 parts separated by dots: header.payload.signature
            const payload = token.split('.')[1];
            // Decode base64 and parse JSON
            const decodedPayload = JSON.parse(atob(payload));
            return decodedPayload.userID || decodedPayload.sub || decodedPayload.id;
        } catch (error) {
            console.error('Error decoding JWT token:', error);
            return null;
        }
    }

    getUserInfo(): any {
        const token = this.getAccessToken();
        if (!token) {
            return null;
        }

        try {
            const payload = token.split('.')[1];
            const decodedPayload = JSON.parse(atob(payload));
            return decodedPayload;
        } catch (error) {
            console.error('Error decoding JWT token:', error);
            return null;
        }
    }

    login(params: any) {
        return this.apiService.post(API_CONFIG.BASE_URL + API_CONFIG.ADMIN_LOGIN, params);
    }

    logout() {
        this.removeToken();
    }

    /**
     * Store Cognito authentication tokens
     * @param tokens - Object containing accessToken, idToken, refreshToken, and expiresIn
     */
    setToken(tokens: { accessToken: string; idToken?: string; refreshToken?: string; expiresIn?: number }) {
        if (tokens.accessToken) {
            localStorage.setItem('accessToken', tokens.accessToken);
        }
        if (tokens.idToken) {
            localStorage.setItem('idToken', tokens.idToken);
        }
        if (tokens.refreshToken) {
            localStorage.setItem('refreshToken', tokens.refreshToken);
        }
        if (tokens.expiresIn) {
            // Store token expiration timestamp
            const expirationTime = new Date().getTime() + (tokens.expiresIn * 1000);
            localStorage.setItem('tokenExpiration', expirationTime.toString());
        }
    }

    /**
     * Get Cognito ID token
     */
    getIdToken(): string | null {
        return localStorage.getItem('idToken');
    }

    /**
     * Get Cognito refresh token
     */
    getRefreshToken(): string | null {
        return localStorage.getItem('refreshToken');
    }

    /**
     * Check if token is expired
     */
    isTokenExpired(): boolean {
        const expirationTime = localStorage.getItem('tokenExpiration');
        if (!expirationTime) {
            return true;
        }
        return new Date().getTime() > parseInt(expirationTime);
    }

    removeToken() {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('idToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('tokenExpiration');
    }

    getCurrentUser() {
        return this.getUserInfo();
    }

    updateProfile(data: any) {
        return this.apiService.put(API_CONFIG.BASE_URL + API_CONFIG.UPDATE_PROFILE, data);
    }

}
